module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "extract"
  }, [_vm._v("Become conscious for a single moment that Life and intelligence are purely spiritual,—neither in nor of matter,—and the body will then utter no complaints.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Mary Baker Eddy, "), _c('em', [_vm._v("Science and Health with Key to the Scriptures")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("I won’t be dying after all, not now, but will go on living dizzily hereafter in reality, half-deaf to reality, in the room perfumed by the fire that our inextinguishable will begins.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Timothy Donnelly, “The New Intelligence”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd337ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm.vue
// module id = 75
// module chunks = 0